import {useState} from "react";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {DropdownAction, DropdownActionItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {Metric} from "@/lib/types/statuspages.ts";
import {StatusPageSystemMetricUpdateModal} from "@/pages/statuspages/tabs/systemMetrics/systemMetricModal/StatusPageSystemMetricUpdateModal.tsx";
import {deleteSystemMetric} from "@/pages/statuspages/utils/quickActions.ts";

interface StatusPageSystemMetricsRowActionsProps {
  metric: Metric;
  statusPageID: number;
}

export const StatusPageSystemMetricsRowActions = ({metric, statusPageID}: StatusPageSystemMetricsRowActionsProps) => {
  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);

  return (
    <>
      <QuickActionsBar
        id={`metric-actions-${metric.id}`}
        actions={[
          <DropdownAction
            id={`metric-actions-dropdown-${metric.id}`}
            items={[
              <DropdownActionItem text="Edit" onClick={() => setShowEdit(true)} />,
              <DropdownActionItem text="Delete" onClick={() => setShowDelete(true)} />,
            ]}
          />,
        ]}
      />
      <StatusPageSystemMetricUpdateModal
        show={showEdit}
        setShow={setShowEdit}
        statusPageID={statusPageID}
        title="Edit System Metric"
        submitBtnText="Save Changes"
        metric={metric}
      />
      <DeleteActionDialog
        show={showDelete}
        title="Delete System Metric"
        onConfirm={async () => {
          await deleteSystemMetric(statusPageID, metric.id);
          setShowDelete(false);
        }}
        onCancel={() => {
          setShowDelete(false);
        }}
      >
        Are you sure you want to delete the System Metric <code>{metric.name}</code>?
      </DeleteActionDialog>
    </>
  );
};
